export const getLabelByField = field => (
    coSellOpportunityFields.find(f => f.field === field) ? coSellOpportunityFields.find(f => f.field === field).label : field
);

export const coSellOpportunityFields = [
    { label: "ID", field: "Id", isVisible: true, isDefault: false },
    { label: "Opportunity Name", field: "Name", isVisible: true, isDefault: true },
    { label: "Source ISV Opportunity", field: "Source_ISV_Opportunity__r.Name", isVisible: true },
    { label: "Account Name", field: "Source_ISV_Opportunity__r.FOR_Account_Name__c", isVisible: true, isDefault: true },
    { label: "End Customer", field: "End_Customer__r.Name", isVisible: true, isDefault: true },
    { label: "Amount", field: "Amount__c", isVisible: true, isDefault: true },
    { label: "Opportunity Owner", field: "OwnerId__r.Name", isVisible: true },
    { label: "ACE Stage", field: "ACE_Stage__c", isVisible: true, isDefault: true },
    { label: "Opportunity Type", field: "Activity_Type__c", isVisible: true },
    { label: "Customer Status", field: "Customer_Status__c", isVisible: true },
    { label: "Close Date", field: "CloseDate__c", isVisible: true },
    { label: "Priority", field: "Priority__c", isVisible: true, isDefault: true },
    { label: "Opportunity Heat", field: "Opportunity_Heat__c", isVisible: true },
    { label: "Business Title", field: "Business_Title__c", isVisible: true },
    { label: "Competitive Tracking", field: "Competitive_Tracking__c", isVisible: true },
    { label: "Customer Use Case", field: "Customer_Use_Case__c", isVisible: true },
    { label: "End Customer HQ", field: "End_Customer_HQ__c", isVisible: true },
    { label: "End Customer Industry", field: "End_Customer_Industry__c", isVisible: true },
    { label: "End Customer State", field: "End_Customer_State__c", isVisible: true },
    { label: "ISV Opportunity Stage", field: "ISV_Opportunity_Stage__c", isVisible: true },
    { label: "Is for Marketplace", field: "Is_for_Marketplace__c", isVisible: true },
    { label: "Leading Cloud", field: "Leading_Cloud__c", isVisible: true },
    { label: "Lost Reason", field: "Lost_Reason__c", isVisible: true },
    { label: "Opportunity source", field: "Marketing_Source__c", isVisible: true },
    { label: "Received Support from Cloud Rep", field: "Needs_Support_from__c", isVisible: true },
    { label: "MP Propensity to Buy", field: "Propensity_to_Buy__c", isVisible: true },
    { label: "Software Revenue Delivery Model", field: "Software_Revenue_Delivery_Model__c", isVisible: true },
    { label: "Sync", field: "Sync__c", isVisible: true },
    { label: "ACE External ID", field: "ACE_External_ID__c", isVisible: true },
    { label: "APN Programs", field: "APN_programs__c", isVisible: true },
    { label: "AWS Products", field: "AWS_products__c", isVisible: true },
    { label: "Account ID", field: "AccountId__c", isVisible: true },
    { label: "Account Team First Call", field: "Account_Team_First_Call__c", isVisible: true },
    { label: "AWS Funding Used", field: "Aws_Funding_Used__c", isVisible: true },
    { label: "Buyer Email", field: "Buyer_Email__c", isVisible: true },
    { label: "Buyer Name", field: "Buyer_Name__c", isVisible: true },
    { label: "Buyer Phone", field: "Buyer_Phone__c", isVisible: true },
    { label: "Buyer Title", field: "Buyer_Title__c", isVisible: true },
    { label: "Campaign", field: "Campaign__c", isVisible: true },
    { label: "Contract Effective Date", field: "Contract_Effective_Date__c", isVisible: true },
    { label: "Customer Business Problem", field: "Customer_Business_Problem__c", isVisible: true },
    { label: "Customer First Meeting", field: "Customer_First_Meeting__c", isVisible: true },
    { label: "Deal Acceleration Reason", field: "Deal_Acceleration_Reason__c", isVisible: true },
    { label: "Deal Term (M)", field: "Deal_Term_M__c", isVisible: true },
    { label: "Description", field: "Description__c", isVisible: true },
    { label: "End Customer AWS Account ID", field: "End_Customer_AWS_Account_ID__c", isVisible: true },
    { label: "End Customer Billing Address", field: "End_Customer_Billing_Address__c", isVisible: true },
    { label: "End Customer City", field: "End_Customer_City__c", isVisible: true },
    { label: "End Customer Duns Number", field: "End_Customer_Duns_Number__c", isVisible: true },
    { label: "End Customer Name", field: "End_Customer_Name__c", isVisible: true },
    { label: "End Customer Postal Code", field: "End_Customer_Postal_Code__c", isVisible: true },
    { label: "End Customer Website", field: "End_Customer_Website__c", isVisible: true },
    { label: "End Customer", field: "End_Customer__c", isVisible: true },
    { label: "Funds Value", field: "Funds_Value__c", isVisible: true },
    { label: "ISV Opportunity Owner", field: "ISV_Opportunity_Owner__c", isVisible: true },
    { label: "Is AWS Referral", field: "Is_AWS_Referral__c", isVisible: true },
    { label: "Last Meeting Date", field: "Last_Meeting_Date__c", isVisible: true },
    { label: "Last Stage Before Close", field: "Last_Stage_Before_Close__c", isVisible: true },
    { label: "Last Sync Date", field: "Last_Sync_Date__c", isVisible: true },
    { label: "Last Sync Status", field: "Last_Sync_Status__c", isVisible: true },
    { label: "MRR", field: "MRR__c", isVisible: true },
    { label: "Marketing Campaign", field: "Marketing_Campaign__c", isVisible: true },
    { label: "Marketing Channels", field: "Marketing_Channels__c", isVisible: true },
    { label: "Marketing Use Cases", field: "Marketing_Use_Cases__c", isVisible: true },
    { label: "Next Step", field: "NextStep__c", isVisible: true },
    { label: "Next Step Date", field: "Next_Step_Date__c", isVisible: true },
    { label: "Next Step Owner", field: "Next_Step_Owner__c", isVisible: true },
    { label: "Next Step POC", field: "Next_Step_POC__c", isVisible: true },
    { label: "On Hold", field: "On_Hold__c", isVisible: true },
    { label: "Opportunity Name", field: "Opportunity_Name__c", isVisible: true },
    { label: "Other Competitor Names", field: "Other_Competitor_Names__c", isVisible: true },
    { label: "Other Solution Description", field: "Other_solution_description__c", isVisible: true },
    { label: "Owner ID", field: "OwnerId__c", isVisible: true },
    { label: "Owner Email", field: "Owner_Email__c", isVisible: true },
    { label: "Owner First Name", field: "Owner_First_Name__c", isVisible: true },
    { label: "Owner Last Name", field: "Owner_Last_Name__c", isVisible: true },
    { label: "Owner Phone", field: "Owner_Phone__c", isVisible: true },
    { label: "Partner Primary Need from AWS", field: "Partner_primary_need_from_AWS__c", isVisible: true },
    { label: "Partner Project Title", field: "Partner_project_title__c", isVisible: true },
    { label: "Partner needs from AWS for Co-sell", field: "Primary_Needs_From_Aws__c", isVisible: true },
    { label: "Probability", field: "Probability__c", isVisible: true },
    { label: "Project Delivery Models", field: "Project_Delivery_Models__c", isVisible: true },
    { label: "Renewal Date", field: "Renewal_date__c", isVisible: true },
    { label: "Sales Activities", field: "Sales_Activities__c", isVisible: true },
    { label: "Solutions Offered", field: "Solutions_offered__c", isVisible: true },
    { label: "Source ISV Opportunity Id", field: "Source_ISV_Opportunity__c", isVisible: true },
    { label: "Target Company", field: "Target_Company__c", isVisible: true },
    { label: "Unique Identifier", field: "Unique_Identifier__c", isVisible: true },
    { label: "Use Case Details", field: "Use_Case_Details__c", isVisible: true },
    { label: "AWS Sales Rep Name", field: "AWS_Sales_Rep_Name__c", isVisible: true },
    { label: "AWS Sales Rep Email", field: "AWS_Sales_Rep_Email__c", isVisible: true },
    { label: "AWS Account Manager Name", field: "AWS_Account_Manager_Name__c", isVisible: true },
    { label: "AWS Account Manager Email", field: "AWS_Account_Manager_Email__c", isVisible: true },
    { label: "Partner Dev Manager Name", field: "Partner_Dev_Manager_Name__c", isVisible: true },
    { label: "Partner Dev Manager Email", field: "Partner_Dev_Manager_Email__c", isVisible: true },
    { label: "WWPS Dev Manager Name", field: "WWPS_Dev_Manager_Name__c", isVisible: true },
    { label: "WWPS Dev Manager Email", field: "WWPS_Dev_Manager_Email__c", isVisible: true },
    { label: "AWS PSM Name", field: "AWS_PSM_Name__c", isVisible: true },
    { label: "AWS PSM Email", field: "AWS_PSM_Email__c", isVisible: true },
    { label: "AWS ISM Name", field: "AWS_ISM_Name__c", isVisible: true },
    { label: "AWS ISM Email", field: "AWS_ISM_Email__c", isVisible: true },
    { label: "Partner Sales Contact Name", field: "Partner_Sales_Contact_Name__c", isVisible: true },
    { label: "Partner Sales Contact Email", field: "Partner_Sales_Contact_Email__c", isVisible: true },
    { label: "Payment Terms", field: "Payment_Terms__c", isVisible: true },
    { label: "Created Date", field: "CreatedDate", isVisible: true },
    { label: "Created By", field: "CreatedBy.Name", isVisible: true },
    { label: "Last Modified Date", field: "LastModifiedDate", isVisible: true },
    { label: "Last Modified By", field: "LastModifiedBy.Name", isVisible: true },
    { label: "Currency ISO Code", field: "CurrencyIsoCode", isVisible: true },
    { label: "Is Deleted", field: "IsDeleted", isVisible: true },
    { label: "Created By Id", field: "CreatedById", isVisible: true },
    { label: "Last Modified By Id", field: "LastModifiedById", isVisible: true },
    { label: "System Modstamp", field: "SystemModstamp", isVisible: true },
    { label: "Last Viewed Date", field: "LastViewedDate", isVisible: true },
    { label: "Last Referenced Date", field: "LastReferencedDate", isVisible: true },
    { label: "ACE Sync Collector Json", field: "ACE_Sync_Collector_Json__c", isVisible: true },
    { label: "ACE Sync Collector Prettier", field: "ACE_Sync_Collector_Prettier__c", isVisible: true },
    { label: "ACE Sync Collector", field: "ACE_Sync_Collector__c", isVisible: true },
];

export const getDefaultFields = () => coSellOpportunityFields.filter(f => f.isDefault);

/**
 * @param {boolean} isDefault
 * @param {string[] | null} keys
 */
export const getDisplayFields = (isDefault = false, keys = null) => {
    const visibleFields = coSellOpportunityFields
        .filter(f => f.isVisible)
        .filter(f => isDefault ? f.isDefault : true);

    if (!keys || keys.length == 0) return visibleFields;

    return keys
        .map(key => visibleFields.find(f => f.field === key))
        .filter(Boolean);
}; 